import { BookingPill } from "PFApp/components/pills/booking_pill";
import useBookingCategories from "PFCore/hooks/use_booking_categories";

import css from "./booking_category_cell.module.scss";

type BookingCategoryCellProps = {
  bookingCategoryId?: number;
};

export const BookingCategoryCell = ({ bookingCategoryId }: BookingCategoryCellProps) => {
  const { getBookingCategory } = useBookingCategories();
  const category = getBookingCategory(bookingCategoryId);
  return category && <BookingPill category={category} withCategoryName className={css.root} />;
};
